import React from 'react';
import DataTable from '../../DataTable/DataTable';
import Tabs from '../../Tabs/Tabs';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import numeral from "numeral";
import clsx from "clsx";

export default class ReservationSegmentCardFolios extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      summary: null,
      dataTableRenderCount: 0,
      folio_items_path: this.props.folio_items_path ? this.props.folio_items_path : null,
      payment_logs_path: this.props.payment_logs_path ? this.props.payment_logs_path : null,
      reservation_segment: this.props.reservation_segment ? this.props.reservation_segment : null,
      transactions_active_tab: this.props.transactions_active_tab ? this.props.transactions_active_tab : 'current_charges',
      date_format: this.props.date_format ? this.props.date_format : null,
      reservation_ru_queue_logs: [],
      refreshFolioTable: false
    }
    this.onChangeActiveTransactionTab = this.onChangeActiveTransactionTab.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "folios",
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="folios">
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("folios")}</h3>
            <div className="table-wrap-panel" >

              <DataTable endpoint={this.props.reservation_segment_folios_path + '?r=' + this.state.dataTableRenderCount} 
                reservation_segment={this.props.reservation_segment} 
                date_format={this.props.date_format} 
                time_format={this.props.time_format}  
                inModal={true} 
                currency_unit={I18n.t('number.currency.format.unit')} 
                delimiter={I18n.t('number.currency.format.delimiter')} 
                separator={I18n.t('number.currency.format.separator')} 
                reLoadData={this.props.reLoadData}
                loadDataCallback={this.props.refreshFolioTableCallback}
              />
            </div>
          </div>
        </div>

          <div className="panel panel-default">
            <div className="panel-body container">
              <h3 className="panel-heading-text">{I18n.t("transactions")}</h3>
            <div className="table-wrap-panel" >
            <Tabs tabs={this.transactionTabs()} />
              <br className="embedded-table-tabs-br"/>
              {
                this.state.transactions_active_tab === 'authorized_payments' 
                ? 
                <DataTable 
                endpoint={this.props.reservation_segment_authorized_payments_path} 
                reservation_segment={this.props.reservation_segment} 
                date_format={this.props.date_format} 
                time_format={this.props.time_format} 
                tab_data_table={true} 
                inModal={true} 
                currency_unit={I18n.t("number.currency.format.unit")} 
                delimiter={I18n.t('number.currency.format.delimiter')} 
                separator={I18n.t('number.currency.format.separator')} /> 
                : 
                null
              }
              {this.state.transactions_active_tab === 'payments' ? <DataTable endpoint={this.props.reservation_segment_payment_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t("number.currency.format.unit")} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
              {
                this.state.transactions_active_tab === 'current_charges' 
                ? 
                <DataTable 
                endpoint={this.props.reservation_segment_charges_path} 
                reservation_segment={this.props.reservation_segment} 
                date_format={this.props.date_format} 
                time_format={this.props.time_format} 
                tab_data_table={true} 
                inModal={true} 
                currency_unit={I18n.t('number.currency.format.unit')} 
                delimiter={I18n.t('number.currency.format.delimiter')} 
                separator={I18n.t('number.currency.format.separator')} 
                /> 
                : 
                null
              }
              {this.state.transactions_active_tab === 'reversed_charges' ? <DataTable endpoint={this.props.reservation_segment_reversal_charges_path} reservation_segment={this.props.reservation_segment} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
            </div>
            </div>
          </div>

        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }


  transactionTabs() {
    const transactionTabs = [
        {
          tabName: I18n.t('current_charges'),
          targetName: 'current_charges',
          classes: this.state.transactions_active_tab === 'current_charges' ? 'active' : null,
          changeHandler: this.onChangeActiveTransactionTab,
        },
        {
          tabName: I18n.t('voided_charges'),
          targetName: 'reversed_charges',
          classes: this.state.transactions_active_tab === 'reversed_charges' ? 'active' : null,
          changeHandler: this.onChangeActiveTransactionTab,
        },
        {
          tabName: I18n.t('payments'),
          targetName: 'payments',
          classes: this.state.transactions_active_tab === 'payments' ? 'active' : null,
          changeHandler: this.onChangeActiveTransactionTab,
        },
        {
          tabName: I18n.t('authorizations'),
          targetName: 'authorized_payments',
          classes: this.state.transactions_active_tab === 'authorized_payments' ? 'active' : null,
          changeHandler: this.onChangeActiveTransactionTab,
        },
      ];


    return (transactionTabs)
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  onChangeActiveTransactionTab(tab) {
    if (tab) {
      this.setState({
        transactions_active_tab: tab,
      })
    }
  }

  getRuLogDatesForSelect = () => {
    $.ajax({
      type: 'POST',
      url: this.props.reservation_ru_queue_logs_path,
      data: {
      }
    }).done((data) => {
      let currentLog = data.ru_queue_logs.shift().id;

      this.setState({
        loading: false,
        visibleRuReversalLog: data.ru_queue_logs[0] ? data.ru_queue_logs[0].id : '',
        reservation_ru_queue_logs: data.ru_queue_logs,
        ruCurrentCharges: currentLog,
      });
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false });
        $('modal-body').scrollTop(0);
      }
    });
  };

}